/**
 * ClassificacaoNivelTemplate — faixas/níveis de pontuação, filhos de Classificacao.
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { RelatedEntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import ClassificacaoNivel from '../../../models/ClassificacaoNivel';
import ClassificacaoModel from '../../../models/Classificacao';

const model = {
  classificacao: {
    exibir: 'main.classificacao.nivel.classificacao',
    visivel: true,
    tipo: 'relacao',
    camporelacao: 'descricao',
    entidade: 'classificacao.entidade',
    template: 'classificacao.template',
    validacao: { obrigatorio: true },
  },
  descricao: { exibir: 'main.classificacao.nivel.descricao', visivel: true, validacao: { obrigatorio: true } },
  cor: { exibir: 'main.classificacao.nivel.cor', visivel: true, template: 'cor.template' },
  limiteinferior: { exibir: 'main.classificacao.nivel.limiteinferior', visivel: true, tipo: 'numeric', keyfilter: 'num', validacao: { obrigatorio: true } },
  limitesuperior: { exibir: 'main.classificacao.nivel.limitesuperior', visivel: true, tipo: 'numeric', keyfilter: 'num', validacao: { obrigatorio: true } },
  peso: { exibir: 'main.classificacao.nivel.peso', visivel: true, tipo: 'numeric', keyfilter: 'num', validacao: { obrigatorio: true } },
  template: { exibir: 'main.classificacao.nivel.template' },
};

const renderers = {
  'classificacao.entidade': ClassificacaoModel,
  'classificacao.template': (rowData) => rowData.classificacao?.descricao || '',
  // Círculo preenchido com a cor cadastrada, em vez do HEX cru na grid — o HEX continua
  // editável no formulário (ModelTextInput), só a exibição em lista muda.
  cor: {
    template: (rowData) => (
      <span
        title={rowData.cor}
        style={{
          display: 'inline-block',
          width: '1.25rem',
          height: '1.25rem',
          borderRadius: '50%',
          backgroundColor: rowData.cor || 'transparent',
          border: '1px solid var(--surface-300)',
        }}
      />
    ),
  },
};

class ClassificacaoNivelFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.classificacao.nivel.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 mt-3"><ModelDropDown model={model.classificacao} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.descricao} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.cor} contexto={contexto} /></div>
            <div className="field col-12 md:col-4 mt-3"><ModelInputNumber model={model.limiteinferior} contexto={contexto} /></div>
            <div className="field col-12 md:col-4 mt-3"><ModelInputNumber model={model.limitesuperior} contexto={contexto} /></div>
            <div className="field col-12 md:col-4 mt-3"><ModelInputNumber model={model.peso} contexto={contexto} /></div>
            <div className="field col-12 mt-3"><ModelTextInput model={model.template} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class ClassificacaoNivelTemplate extends Component {
  render() {
    return (
      <RelatedEntityGrid
        entidade={ClassificacaoNivel}
        model={model}
        identidade="main.classificacao.nivel"
        icone="pi-flag"
        permissoes={this.props.permissoes}
        storageKey="dt-classificacaoniveis"
        processos={[]}
        relacionados={[]}
        renderers={renderers}
        configuracao={this.props.configuracao}
        formulario={(m, ctx) => <ClassificacaoNivelFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default ClassificacaoNivelTemplate;
